
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor2Off as ObiResistor2OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-2-off.js';
 
 
 

 
 export const ObiResistor2Off = createComponent({
   react: React,
   tagName: 'obi-resistor-2-off',
   elementClass: ObiResistor2OffElement,
   events: {
     
   }
  });
 
 